// extracted by mini-css-extract-plugin
export default {"cardListTitle":"Payment_cardListTitle__ojh2J","layoutWrapper":"Payment_layoutWrapper__XHtlU","cardListWrapper":"Payment_cardListWrapper__qOcen"};